import TheGrid from '@/views/campaigns/inpar/criteria/grid'
import Edit from '@/views/campaigns/inpar/criteria/edit'
import TheImport from '@/views/campaigns/inpar/criteria/import'

export default {
  path: '/campaigns/inpar/criteria',
  redirect: '/campaigns/inpar/criteria/index',
  name: 'criteria',
  meta: {
    auth: {
      redirect: {
        name: 'criteria.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Critérios'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'criteria.index',
    component: TheGrid,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'criteria.create',
    component: Edit,
    meta: {
      auth: true,roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Criar'
    }
  }, {
    path: 'import',
    name: 'criteria.import',
    component: TheImport,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Importar'
    }
  }, {
    path: 'edit/:id',
    name: 'criteria.edit',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Editar'
    }
  }]
}
